<div class="self-info">

  <form *ngIf="submitter.matchingDupe" [action]="actionUrl" method="POST" #emailMatchForm>
    <input type="hidden" name="user[login]" [value]="submitter.matchingDupe.found_user_uuid">
    <input type="hidden" name="user[user_duplicate_lookup_id]" [value]="submitter.matchingDupe.user_duplicate_lookup_id">
    <input type="hidden" name="authenticity_token" [value]="csrfToken">
    <se-fe-alert seFeDataType="caution">
      {{ submitter.matchingEmail }} is already in use on a SportsEngine account.
      <button seFeLink type="submit" (click)="emailMatchSignIn()">Sign in using this email</button>
    </se-fe-alert>
  </form>

  <se-fe-alert *ngIf="submitter.agelock" seFeDataType="critical" class="agelock-alert">
    You are not eligible to create a SportsEngine account.
    Please ask your parent or guardian to create an account.
  </se-fe-alert>

  <div class="self-info-icon">
    <se-fe-icon
      seFeDataName="spot_id"
      seFeDataSize="950"
      seFeDataAriaLabel="child">
    </se-fe-icon>
  </div>
  <div class="self-info-title">
    <se-po-highlight-label
      label="Your Info"
      theme="adult">
    </se-po-highlight-label>
  </div>

  <div role="content" class="self-info-content">
    <div *ngIf="!ready">
      <se-fe-spinner
        [seFeDataSize]="900"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true"
      ></se-fe-spinner>
    </div>
    <form
      *ngIf="ready"
      [formGroup]="form"
      (ngSubmit)="submitter.validateAndSubmit(form, store, {
        personaInfo: personaInfo.form, contactInfo: contactInfo.form
      })"
      novalidate>

      <section>
        <se-po-persona-info #personaInfo
          formControlName="accountInfo"
          [requiredFields]="isTeamUnifyBrand ? ['name', 'dateOfBirth'] : ['name', 'gender', 'dateOfBirth']"
          [labels]="{
            name: 'Name',
            gender: isTeamUnifyBrand ? '' : 'Gender',
            dateOfBirth: 'Birthday'
          }"
          [accountAgeRequired]="true"
          [showDateOfBirthLearnMore]="true"
          [genderDisabled]="isTeamUnifyBrand"
        ></se-po-persona-info>
      </section>

      <section>
        <h3>
          Contact and Sign In Info
        </h3>

        <se-po-contact-info #contactInfo
          formControlName="contactInfo"
          showHelp="true"
          (init)="onContactInfoFormInit($event)"
        ></se-po-contact-info>
      </section>

      <div class="form-submit">
        <se-fe-button
          seFeDataEmphasis="high"
          seFeDataType="submit"
          [seFeDataIsLoading]="submitter.submitting"
          [seFeDataFullWidth]="true">Add Your Profile</se-fe-button>
      </div>
    </form>
  </div>
</div>
